
export default {
  name: 'NotFoundComponent'
}
